import { IfAuthenticated, useLogout, useUser } from '@tbitop/authentication';
import { useMandanten } from '@tbitop/mandanten';
import { useRouting } from '@tbitop/routing';
import { SideMenuItem, SideMenuItems, SideMenuUserItem } from '@tbitop/side-menu';
import { ButtonCtaGhost, ModalHeader, SideMenu } from '@tbitop/ui';
import { noop } from 'lodash-es';
import { AddressBook, Info, Shield, SignOut } from 'phosphor-react';
import type { PropsWithChildren } from 'react';
import { createContext, useCallback, useContext, useState } from 'react';
import { useBackButton } from './backbutton';
import { Link } from './routing';

const SideMenuContext = createContext(noop);

export const SideMenuProvider = ({ children }: PropsWithChildren<unknown>) => {
  const [sideMenuOpen, setSideMenuOpen] = useState(false);

  const open = useCallback(() => setSideMenuOpen(true), []);

  return (
    <SideMenuContext.Provider value={open}>
      {children}
      <MobileSideMenu sideMenuOpen={sideMenuOpen} onClose={() => setSideMenuOpen(false)} />
    </SideMenuContext.Provider>
  );
};

export const useSideMenu = () => {
  return useContext(SideMenuContext);
};

type MobileSideMenuProps = {
  sideMenuOpen: boolean;
  onClose: () => void;
};

export const MobileSideMenu = ({ sideMenuOpen, onClose }: MobileSideMenuProps) => {
  const { query } = useRouting();
  useBackButton(onClose, sideMenuOpen);

  return (

    <SideMenu label="Nutzersitzung und Rechtliches" isOpen={sideMenuOpen} onClose={onClose} preventAutofocusOnOpen>
      <ModalHeader onClose={onClose} />
      <IfAuthenticated>
        <AuthenticatedUser />
      </IfAuthenticated>
      <SideMenuItems>
        <SideMenuItem.Root>
          <a href="https://team-beverage.de/info/impressum">
            <SideMenuItem.Content Icon={AddressBook} name="Impressum" />
          </a>
        </SideMenuItem.Root>
        <SideMenuItem.Root >
          <Link href={{ query: { ...query, datenschutz: '' } }} onClick={onClose}>
            <SideMenuItem.Content Icon={Shield} name="Datenschutz" />
          </Link>
        </SideMenuItem.Root>
        <SideMenuItem.Root >
          <Link href={{ query: { ...query, 'app-info': '' } }} onClick={onClose}>
            <SideMenuItem.Content Icon={Info} name="App Informationen" />
          </Link>
        </SideMenuItem.Root>
      </SideMenuItems>
      <IfAuthenticated>
        <LogoutButton />
      </IfAuthenticated>
    </SideMenu>
  );
};

const AuthenticatedUser = () => {
  const user = useUser();
  const { mandanten, currentMandant, switchOrganization } = useMandanten();
  const selectableMandanten = mandanten.filter(mandant => mandant.hasSalesPlanner);

  return (
    <SideMenuUserItem
      user={user}
      currentMandant={currentMandant}
      mandanten={selectableMandanten}
      onMandantSelect={switchOrganization} />
  );
};

const LogoutButton = () => {
  const logout = useLogout();

  return (
    <ButtonCtaGhost className="self-start" onClick={logout} icon={SignOut}>Logout</ButtonCtaGhost>
  );
};
